import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { DropOutCheck } from 'web/components/common/modal';
import { postListItemNameRequest } from 'shared/actions/modal.action';

import {
  postUserDeviceRequest,
  deleteUserDeviceRequest,
} from 'shared/actions/auth.action';

import jwt from 'jsonwebtoken';
import ChannelService from 'shared/utils/ChannelService';
import { getCookie } from 'shared/utils/cookie';

@withRouter
@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  { postUserDeviceRequest, deleteUserDeviceRequest, postListItemNameRequest },
)
class DropOutCheckContainer extends Component {
  state = {
    selectItem: null, // idx
  };

  addChannelIoScript = () => {
    const { auth = {} } = this.props;
    const { user = {} } = auth;
    const access_token = getCookie('dr_access_token');
    let token = null;

    window.channelIo = ChannelService;
    window.channelIo.loadScript();

    let channelSettings = { ...window.channelPluginSettings };
    if (access_token && user.type !== 'GUEST') {
      token = jwt.decode(access_token).uid;
      channelSettings.userId = token;
    }
    // console.log({ token: token, channelSettings });
    window.channelIo.boot(channelSettings);
    // console.log({ channelIo: window.channelIo });
  };

  componentDidMount() {
    this.addChannelIoScript();
  }

  handleSubmit = e => {
    // console.log(`handleSubmit`);
  };

  render() {
    return (
      <DropOutCheck
        handlePopup={this.props.popupHandler}
        handleOneToOne={() => {
          alert('준비중인 기능입니다.');
        }}
      />
    );
  }
}

export default DropOutCheckContainer;
